import React, { useState } from 'react'
import styles from './header_.module.css'
import { Drawer } from 'antd';
import getStringsBasedLang from '../../strings/get_strings'
import { useNavigate } from 'react-router-dom';
import BtnLogin from './btn_login';
import BtnLogout from './btn_logout';
import BtnSelectLang from './btn_select_lang';

export default function HeaderMobile(props) {

    const [visible, setVisible] = useState(false);
    let navigate = useNavigate()
    const lang = localStorage.getItem("lang")
    const onClose = () => {
        setVisible(false);
    }
    const itemHandler = (item) => {
        setVisible(false)
        navigate(item)
    }

    const renderItem = (txt, icon) => {
        return (
            <div className='flex justify-center'>
                <img src={require(`../../assets/icons/${icon}.png`)} alt="" />
                <span className='w-32'>{txt}</span>
            </div>
        )
    }
    return (
        <div className={styles.mobile_mode_container}>
            <div className={`${styles.drawer_container} ${lang === 'en' ? 'text-left' : ''}`} onClick={() => setVisible(true)}>
                <img src={require('../../assets/icons/open-menu.svg').default} alt="Icon" />
            </div>
            <div>{props.logo}</div>
            <Drawer title={<span className='primary_text_color font-extrabold text-xl'>{getStringsBasedLang("general_multiScanner")}</span>} placement={lang === 'en' ? 'left' : 'right'} onClose={onClose} visible={visible}>
                <div className='flex flex-col items-center text-center'>
                    <div className='cursor-pointer font-bold text-lg border_bottom w-full py-4 primary_text_color' onClick={() => itemHandler('/')}>{renderItem(getStringsBasedLang("general_headerHome"), 'home_mobile')}</div>
                    <div className='cursor-pointer font-bold text-lg border_bottom w-full py-4 primary_text_color' onClick={() => itemHandler('/search')}>{renderItem(getStringsBasedLang("general_search"), 'search_mobile')}</div>
                    <div className='cursor-pointer font-bold text-lg border_bottom w-full py-4 primary_text_color' onClick={() => itemHandler('/aboutApp')}>{renderItem(getStringsBasedLang("footer_aboutSystem"), 'about')}</div>
                    <div className='cursor-pointer font-bold text-lg border_bottom w-full py-4 primary_text_color' ><a className='primary_text_color hover:text-current' target="_blank" rel="noopener noreferrer" href={`${(!lang || lang === 'en' ? 'https://supporten.cyberno.ir/en/blog/multiscanner-intro' : 'https://support.cyberno.ir/fa/blog/multiscanner-intro')}`}>{renderItem(getStringsBasedLang("general_faq"), 'faq')}</a></div>
                </div>
                <div className='flex flex-col justify-center items-center mt-5'>
                    <div className='flex justify-center'><BtnSelectLang /></div>
                    <div className='flex justify-center mt-5'>
                        {
                            props.info && props.info.user_level !== 'guest' ?
                                <div className='flex flex-col'>
                                    <button onClick={() => navigate('/changePassword')} className='w-32 mb-5 primary_text_color rounded-2xl border-0 bg-green-300 py-2 cursor-pointer'>{getStringsBasedLang("general_changePass")}</button>

                                    <BtnLogout isMobile={true} logoutHandler={() => props.logout()} />
                                </div>
                                :
                                <BtnLogin onClickHandler={() => navigate('/login')} />
                        }
                    </div>
                </div>
            </Drawer>
        </div >
    )
}
